import * as z from "zod/v4";
import { ResultSchemaOf } from "./result.ts";
import { ulid } from "@std/ulid";
import { IsoDateTimeSchema } from "./iso.ts";
import { nowIsoString } from "../util/date.ts";

export const ProjectSchema = z.object({
  id: z.ulid().default(ulid),
  title: z.string().default("Untitled"),
  description: z.string().default(""),
  phase: z.string().nullable(),
  focus: z.string().default(""),
  agent_id: z.ulid().optional(),
  created_at: IsoDateTimeSchema.default(nowIsoString),
  updated_at: IsoDateTimeSchema.default(nowIsoString),
});

export type Project = z.infer<typeof ProjectSchema>;

export const ProjectResultSchema = ResultSchemaOf(ProjectSchema, z.string());

export type ProjectResult = z.infer<typeof ProjectResultSchema>;

/** Schema for  */
export const ProjectInfoSchema = ProjectSchema.omit({
  created_at: true,
  updated_at: true,
});

export type ProjectInfo = z.infer<typeof ProjectInfoSchema>;

export const ProjectItemSchema = z.object({
  id: z.ulid(),
  title: z.string(),
  description: z.string(),
});

export type ProjectItem = z.infer<typeof ProjectItemSchema>;

export const ProjectItemResultSchema = ResultSchemaOf(
  ProjectItemSchema,
  z.string(),
);
export type ProjectItemResult = z.infer<typeof ProjectItemResultSchema>;

export const ProjectListSchema = z.array(ProjectItemSchema);
export type ProjectList = z.infer<typeof ProjectListSchema>;

export const ProjectListResultSchema = ResultSchemaOf(
  ProjectListSchema,
  z.string(),
);
export type ProjectListResult = z.infer<typeof ProjectListResultSchema>;
